<template lang="pug">
  v-slide-y-transition(mode="out-in")

    v-container(fluid v-if="!isLoading()")

      v-form(ref="commercialChainForm", @submit='handleSubmit')

        v-card(class="mb2")

          v-card-title
            h3.headline Datos generales

          v-card-text
            v-text-field(:label="$t('Nombre')", v-model="commercialChain.name", :rules="validation.required", required)
            v-text-field(:label="$t('Comisión')", v-model="commercialChain.commission", required)

          v-card-actions
            v-btn(color="red" dark @click="$router.push('/commercial_chains')") Cancelar
            v-spacer
            v-btn(color="primary", type="submit") Guardar

    v-container(fluid fill-height v-else)
      v-layout(flex align-center justify-center)
        v-progress-circular(indeterminate, color="primary", :size="128", :width="2")
</template>

<script>
  import validation from '@/utils/validation';

  const emptyCommercialChain = {
    id: null,
    name: '',
    commission: null,
  };

  export default {
    data() {
      return {
        commercialChain: null,
        loading: {
          commercialChain: false,
          saving: false,
        },
        validation,
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      isLoading() {
        return this.loading.commercialChain
          || this.loading.saving;
      },
      fetchData() {
        this.loading.commercialChain = true;

        if (this.$route.params.id) {
          api.get(`/commercial_chains/${this.$route.params.id}`).then((res) => {
            this.commercialChain = res.data;
          }).catch(this.handleError)
          .finally(() => { this.loading.commercialChain = false; });
        } else {
          this.commercialChain = Object.assign({}, emptyCommercialChain);
          this.loading.commercialChain = false;
        }
      },
      handleSubmit() {
        if (this.$refs.commercialChainForm.validate()) {
          this.loading.saving = true;
          if (this.commercialChain.id === null) {
            api.post('/commercial_chains', this.commercialChain).then(() => {
              this.$router.push('/commercial_chains');
            }).catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
          } else {
            api.put(`/commercial_chains/${this.commercialChain.id}`, this.commercialChain).then(() => {
              this.$router.push('/commercial_chains');
            }).catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
          }
        }
      },
      handleError(err) {
        // eslint-disable-next-line no-console
        console.error(err);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/CommercialChains/CommercialChainForm.vue